import { request } from './common';

export type LeLiveExportFormat = 'csv' | 'xlsx';

interface DownloadRequestInit extends RequestInit {
  download?: boolean;
}

function basePath() {
  return window.configs.API_HOST + '/api/occasions/v1';
}

export function downloadLeLiveRegistrationsReport(format: LeLiveExportFormat): Promise<Blob> {
  const options: DownloadRequestInit = {
    credentials: 'include',
    method: 'GET',
    download: true,
  };
  return request(`${basePath()}/le-live/registrations/export?format=${format}`, options);
}
